"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var HeadRow_1 = __importDefault(require("./HeadRow"));

exports.default = HeadRow_1.default;